export default "__VITE_ASSET__BNjJTW0h__"